// @generated by protoc-gen-es v2.10.2
// @generated from file lda/v1alpha1/reports.proto (package lda, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file lda/v1alpha1/reports.proto.
 */
export const file_lda_v1alpha1_reports = /*@__PURE__*/
  fileDesc("ChpsZGEvdjFhbHBoYTEvcmVwb3J0cy5wcm90bxIDbGRhIooBCgZSZXBvcnQSCgoCaWQYASABKAUSDAoEbmFtZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRIRCglpbWFnZV91cmwYBCABKAkSEAoIaW5jbHVkZWQYBiABKAgSEAoIZmVhdHVyZWQYByABKAgSDAoEbWV0YRgIIAEoCRIMCgR0YWdzGAkgAygJIiIKEkxpc3RSZXBvcnRzUmVxdWVzdBIMCgR0YWdzGAIgAygJIjMKE0xpc3RSZXBvcnRzUmVzcG9uc2USHAoHcmVwb3J0cxgBIAMoCzILLmxkYS5SZXBvcnQiLAoXSXNSZXBvcnRJbmNsdWRlZFJlcXVlc3QSEQoJcmVwb3J0X2lkGAEgASgFIiwKGElzUmVwb3J0SW5jbHVkZWRSZXNwb25zZRIQCghpbmNsdWRlZBgBIAEoCCIlChBHZXRSZXBvcnRSZXF1ZXN0EhEKCXJlcG9ydF9pZBgBIAEoBSIwChFHZXRSZXBvcnRSZXNwb25zZRIbCgZyZXBvcnQYASABKAsyCy5sZGEuUmVwb3J0IhsKGUdldEZlYXR1cmVkUmVwb3J0c1JlcXVlc3QiOgoaR2V0RmVhdHVyZWRSZXBvcnRzUmVzcG9uc2USHAoHcmVwb3J0cxgBIAMoCzILLmxkYS5SZXBvcnQiGQoXR2V0QWxsUmVwb3J0VGFnc1JlcXVlc3QiKAoYR2V0QWxsUmVwb3J0VGFnc1Jlc3BvbnNlEgwKBHRhZ3MYASADKAkiIAoeTGlzdFJlcG9ydHNXaXRoQ2F0ZWdvcnlSZXF1ZXN0IlEKDlJlcG9ydENhdGVnb3J5EgwKBG5hbWUYASABKAkSEwoLZGVzY3JpcHRpb24YAiABKAkSHAoHcmVwb3J0cxgEIAMoCzILLmxkYS5SZXBvcnQiSgofTGlzdFJlcG9ydHNXaXRoQ2F0ZWdvcnlSZXNwb25zZRInCgpjYXRlZ29yaWVzGAEgAygLMhMubGRhLlJlcG9ydENhdGVnb3J5Mu0DCg5SZXBvcnRzU2VydmljZRJACgtMaXN0UmVwb3J0cxIXLmxkYS5MaXN0UmVwb3J0c1JlcXVlc3QaGC5sZGEuTGlzdFJlcG9ydHNSZXNwb25zZRJPChBJc1JlcG9ydEluY2x1ZGVkEhwubGRhLklzUmVwb3J0SW5jbHVkZWRSZXF1ZXN0Gh0ubGRhLklzUmVwb3J0SW5jbHVkZWRSZXNwb25zZRI6CglHZXRSZXBvcnQSFS5sZGEuR2V0UmVwb3J0UmVxdWVzdBoWLmxkYS5HZXRSZXBvcnRSZXNwb25zZRJVChJHZXRGZWF0dXJlZFJlcG9ydHMSHi5sZGEuR2V0RmVhdHVyZWRSZXBvcnRzUmVxdWVzdBofLmxkYS5HZXRGZWF0dXJlZFJlcG9ydHNSZXNwb25zZRJPChBHZXRBbGxSZXBvcnRUYWdzEhwubGRhLkdldEFsbFJlcG9ydFRhZ3NSZXF1ZXN0Gh0ubGRhLkdldEFsbFJlcG9ydFRhZ3NSZXNwb25zZRJkChdMaXN0UmVwb3J0c1dpdGhDYXRlZ29yeRIjLmxkYS5MaXN0UmVwb3J0c1dpdGhDYXRlZ29yeVJlcXVlc3QaJC5sZGEuTGlzdFJlcG9ydHNXaXRoQ2F0ZWdvcnlSZXNwb25zZUIwWi5naXRodWIuY29tL2RhbnRlLWxhYnMvbGRhL2dlbi9sZGEvdjFhbHBoYTE7bGRhYgZwcm90bzM");

/**
 * Describes the message lda.Report.
 * Use `create(ReportSchema)` to create a new message.
 */
export const ReportSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 0);

/**
 * Describes the message lda.ListReportsRequest.
 * Use `create(ListReportsRequestSchema)` to create a new message.
 */
export const ListReportsRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 1);

/**
 * Describes the message lda.ListReportsResponse.
 * Use `create(ListReportsResponseSchema)` to create a new message.
 */
export const ListReportsResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 2);

/**
 * Describes the message lda.IsReportIncludedRequest.
 * Use `create(IsReportIncludedRequestSchema)` to create a new message.
 */
export const IsReportIncludedRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 3);

/**
 * Describes the message lda.IsReportIncludedResponse.
 * Use `create(IsReportIncludedResponseSchema)` to create a new message.
 */
export const IsReportIncludedResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 4);

/**
 * Describes the message lda.GetReportRequest.
 * Use `create(GetReportRequestSchema)` to create a new message.
 */
export const GetReportRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 5);

/**
 * Describes the message lda.GetReportResponse.
 * Use `create(GetReportResponseSchema)` to create a new message.
 */
export const GetReportResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 6);

/**
 * Describes the message lda.GetFeaturedReportsRequest.
 * Use `create(GetFeaturedReportsRequestSchema)` to create a new message.
 */
export const GetFeaturedReportsRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 7);

/**
 * Describes the message lda.GetFeaturedReportsResponse.
 * Use `create(GetFeaturedReportsResponseSchema)` to create a new message.
 */
export const GetFeaturedReportsResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 8);

/**
 * Describes the message lda.GetAllReportTagsRequest.
 * Use `create(GetAllReportTagsRequestSchema)` to create a new message.
 */
export const GetAllReportTagsRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 9);

/**
 * Describes the message lda.GetAllReportTagsResponse.
 * Use `create(GetAllReportTagsResponseSchema)` to create a new message.
 */
export const GetAllReportTagsResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 10);

/**
 * Describes the message lda.ListReportsWithCategoryRequest.
 * Use `create(ListReportsWithCategoryRequestSchema)` to create a new message.
 */
export const ListReportsWithCategoryRequestSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 11);

/**
 * Describes the message lda.ReportCategory.
 * Use `create(ReportCategorySchema)` to create a new message.
 */
export const ReportCategorySchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 12);

/**
 * Describes the message lda.ListReportsWithCategoryResponse.
 * Use `create(ListReportsWithCategoryResponseSchema)` to create a new message.
 */
export const ListReportsWithCategoryResponseSchema = /*@__PURE__*/
  messageDesc(file_lda_v1alpha1_reports, 13);

/**
 * @generated from service lda.ReportsService
 */
export const ReportsService = /*@__PURE__*/
  serviceDesc(file_lda_v1alpha1_reports, 0);

